export const ANNUAL_PRICE_MULTIPLIER: number = 12;
